import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { ListBase } from 'src/app/components/core/_infrastructure/classes/listBase';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { FilterSearchingBaseViewModel } from 'src/app/components/core/_infrastructure/types/common';
import { proxiedPropertiesOf } from 'src/app/components/core/_infrastructure/types/utils';
import { TVariedadViewModel, VariedadItemResultsViewModel } from '../variedad.types';
import { DialogMode, DialogSelectionMode } from 'src/app/components/_campanias/types/enum';

@Component({
    selector: 'app-variedad-list',
    templateUrl: './variedad-list.component.html',
})
export class VariedadListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: VariedadItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;
    @Input() dialogMode: DialogMode;
    @Input() selectionMode: DialogSelectionMode = DialogSelectionMode.None;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() edit = new EventEmitter<number | null>();
    @Output() selectVariedad = new EventEmitter<any>();
    @Output() undoSelectVariedad = new EventEmitter<any>();

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    arraySelected: TVariedadViewModel[] = [];
    dialogModeEnum = DialogMode;
    dialogSelectionMode = DialogSelectionMode;

    constructor(protected notificationService: NotificationService) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const variedadVM = proxiedPropertiesOf<TVariedadViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: variedadVM.Id?.toString(), header: 'Id', display: 'none' },
            { field: variedadVM.Descripcion?.toString(), header: 'Variedad' },
            { field: variedadVM.NombreCientifico?.toString(), header: 'Nombre Científico' },
            { field: variedadVM.CodigoEppo?.toString(), header: 'Código EPPO' },
            { field: variedadVM.NombreComun?.toString(), header: 'Nombre Común' },
            { field: variedadVM.Grupo, header: 'Grupo' },
            { field: variedadVM.Forma, header: 'Forma' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            setTimeout(() => {
                this.loading = false;
                if (this.turboTable) {
                    this.turboTable.sortOrder = this.lastFilter?.Asc || 0;
                    this.turboTable.sortField = this.lastFilter?.OrderBy;
                    this.turboTable.first = this.lastFilter?.PageNumber * this.result.PageSize;
                }
            }, 100);
        }
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField,
        };

        this.search.emit(f);
    }

    onEdit(item: TVariedadViewModel): void {
        this.edit.emit(item?.Id);
    }

    /**
     * This event is used only when in selectionMode.
     * It will have to tell which kind of selection the user has made.
     * The data selected will be raised alongside the type of selection.
     * @param $event
     * @param rowData TVariedadViewModel
     */
    onSelect($event: any, rowData: any): void {
        $event.stopPropagation(); // Esto evita que luego se ejecute además el manejador del doble-click
        if (this.selectionMode === DialogSelectionMode.Multiple) {
            const found = this.arraySelected.find(item => item.Id === rowData.Id);
            if (!found) {
                // El usuario ha deseleccionado la fila
                this.undoSelectVariedad.emit(rowData);
                return;
            }
        }
        this.setSelection(rowData, false);
    }

    onSelectAll($event: any): void {
        this.arraySelected = this.result?.ResultList.slice();
        this.arraySelected.forEach(rowData => {
            this.setSelection(rowData, false);
        });
    }

    /**
     * This event is used only when in selectionMode.
     * It will have to tell which kind of selection the user has made.
     * The data selected will be raised alongside the type of selection.
     * @param $event
     * @param rowData TVariedadViewModel
     */
    onRowDblClick($event: any, rowData: any): void {
        $event.stopPropagation();
        this.setSelection(rowData, true);
    }

    private setSelection(rowData: any, dblclick: boolean): void {
        if (this.selectionMode !== DialogSelectionMode.None) {
            this.selectVariedad.emit({ selection: rowData, dblclick: dblclick });
        }
    }
}
